import "./projects.scss";
import GMIU from "../../img/GMIU.png";
import LiveKitab from "../../img/LiveKitab.png";
import MyBusinessPortal from "../../img/MyBusinessPortal.png";
import TaskManager from "../../img/TaskManager.png";

function projects() {
  return (
    <section className="main-container" id="projects">
      <hr />
      <div className="container">
        <h2 className="heading">
          <span className="heading-main">Projects</span>
          <span className="heading-sub">
            Discover my web development journey through the projects I've
            created, showcasing my skills and commitment.
          </span>
        </h2>
        <div className="project-container">
          <div className="project">
            <div className="project-heading">GMIU</div>
            <div className="project-description">
              <div className="project-image">
                <img src={GMIU} />
              </div>
              Designed and implemented an admin panel to dynamically showcase
              data on the GMIU website, enhancing user experience and optimizing
              data accessibility.
            </div>
            <div className="project-button">
              <a href="https://gmiu.edu.in/gmiu/website/">
                <button>Project Link</button>
              </a>
            </div>
          </div>
          <div className="project">
            <div className="project-heading">LiveKitab</div>
            <div className="project-description">
              <div className="project-image">
                <img src={LiveKitab} />
              </div>
              Developed admin and mentor panels to streamline the upload process
              for courses, assignments, and tests, ensuring efficient approval
              workflows for administrators and seamless access for students.
            </div>
            <div className="project-button">
              <a href="http://livekitab.com/">
                <button>Project Link</button>
              </a>
            </div>
          </div>
          <div className="project">
            <div className="project-heading">My Business Portal</div>
            <div className="project-description">
              <div className="project-image">
                <img src={MyBusinessPortal} />
              </div>
              My business Portal admin panel empowers users to effortlessly
              create and enhance their business presence by adding comprehensive
              details, fostering optimal growth within the portal ecosystem.
            </div>
            <div className="project-button">
              <a href="https://github.com/SohamM2003/mybusinessportal">
                <button>Project Code</button>
              </a>
            </div>
          </div>
          <div className="project">
            <div className="project-heading">Task Manager</div>
            <div className="project-description">
              <div className="project-image">
                <img src={TaskManager} />
              </div>
              The React based task manager enables users to effortlessly add,
              manage, and delete tasks on the portal, leveraging the integration
              of Node.js, Express.js, and MongoDB for enhanced efficiency.
            </div>
            <div className="project-button">
              <a href="">
                <button>Project Code</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default projects;
